import { Button } from '@/app/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/app/components/ui/dialog'
import { Input } from '@/app/components/ui/input'

export interface ChangeCashierModalProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  pin: string
  setPin: (pin: string) => void
  handleReleaseRegister: () => void
  isSubmitting?: boolean
}

export function ChangeCashierModal({
  open,
  onOpenChange,
  pin,
  setPin,
  handleReleaseRegister,
  isSubmitting = false,
}: ChangeCashierModalProps) {
  return (
    <Dialog
      open={open}
      onOpenChange={(nextOpen) => {
        if (!nextOpen) setPin('')
        onOpenChange(nextOpen)
      }}
    >
      <DialogContent
        className="sm:max-w-md"
        onInteractOutside={(event) => event.preventDefault()}
        onEscapeKeyDown={(event) => event.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Liberar Caja Registradora</DialogTitle>
          <DialogDescription className="sr-only">
            Liberar la asignación de la caja actual para seleccionar una diferente
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4">
          <div className="rounded-lg border border-yellow-200 bg-yellow-50 p-4">
            <p className="text-sm text-yellow-900">
              Para desasignar esta caja y seleccionar otra, ingresa el PIN global de cajas configurado en Plataforma.
            </p>
          </div>

          <div className="space-y-2">
            <label htmlFor="release-register-pin" className="text-sm font-medium text-inherit">
              PIN de autorización:
            </label>
            <Input
              id="release-register-pin"
              type="password"
              inputMode="numeric"
              autoComplete="one-time-code"
              maxLength={4}
              pattern="\d{4}"
              value={pin}
              onChange={(e) => setPin(e.target.value.replace(/\D/g, '').slice(0, 4))}
              placeholder="••••"
              disabled={isSubmitting}
            />
          </div>

          <div className="flex gap-2">
            <Button
              onClick={handleReleaseRegister}
              disabled={pin.length !== 4 || isSubmitting}
              className="flex-1"
            >
              {isSubmitting ? 'Liberando...' : 'Liberar Caja'}
            </Button>
            <Button
              variant="outline"
              onClick={() => {
                setPin('')
                onOpenChange(false)
              }}
              disabled={isSubmitting}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
